import cn from 'classnames'
import { Switch } from '../../switch'
import { Typography } from '../../typography'
import styles from './SwitchField.module.css'
import { SwitchFieldProps } from './SwitchField.types'

export function SwitchField({
  label,
  id,
  disabled,
  className,
  variant = 'transparent',
  supportingLabel,
  ...rest
}: SwitchFieldProps) {
  const wrapperClasses = cn(
    styles.wrapper,
    className,
    {
      [styles.outlined]: variant === 'outlined',
      [styles.disabled]: disabled,
    },
  )

  return (
    <label htmlFor={id} className={wrapperClasses}>
      <Switch
        className={styles.switch}
        disabled={disabled}
        id={id}
        aria-labelledby={label ? `${id}-label` : undefined}
        aria-label={!label && rest['aria-label'] ? rest['aria-label'] : undefined}
        {...rest}
      />
      <div className={styles.textWrapper}>
        {label && (
          <Typography variant="body-m-regular-tight" id={`${id}-label`}>
            {label}
          </Typography>
        )}
        {supportingLabel && (
          <Typography className={styles.supportingLabel} variant="body-s-regular-tight" id={`${id}-supporting-label`}>
            {supportingLabel}
          </Typography>
        )}
      </div>
    </label>
  )
}
